import { SelectedProductDTO } from "@models/platform-analysis/entities/steps/feature";
import { summaryBusinessMetricAnalysisDisqualifiedTableRowsSelectorsByIndex } from "@redux/slices/platform-analysis";
import { memo } from "react";
import { useSelector } from "react-redux";
import { SummaryAnalysisTable } from "../../features/table-components/container";
import { TableViewMode } from "@models/platform-analysis/enums/tableViewMode";

export const AppendixBusinessMetricAnalysisTable = memo(
  ({
    index,
    selectedProducts,
  }: {
    index: number;
    selectedProducts: SelectedProductDTO[];
  }) => {
    const storedTableRows = useSelector(
      summaryBusinessMetricAnalysisDisqualifiedTableRowsSelectorsByIndex(index)
        .selectAll,
    );

    return (
      <SummaryAnalysisTable
        isReview={true}
        rows={storedTableRows}
        selectedProducts={selectedProducts}
        wrapperProps={{
          isAppendix: true,
          noSelectionColumn: true,
          showAnalysisScore: true,
          showFeatureTooltip: false,
          viewMode: TableViewMode.Detail,
        }}
      />
    );
  },
);
